import { useState, useEffect, useCallback } from 'react';
import { cognitoService } from '../services/cognitoService';

export const useCognito = () => {
  const [cognitoStatus, setCognitoStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get Cognito service status
  const getStatus = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const status = await cognitoService.getStatus();
      setCognitoStatus(status);
      return status;
    } catch (err) {
      console.error('Cognito status error:', err);
      setError(err.error || 'Failed to get Cognito status');
      // Don't throw here to prevent infinite loops
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Link existing account with Cognito
  const linkAccount = async (email, password, currentToken) => {
    try {
      setLoading(true);
      setError(null);
      const result = await cognitoService.linkAccount(email, password, currentToken);
      return result;
    } catch (err) {
      setError(err.error || 'Failed to link account');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Get initial status only once
    let mounted = true;
    
    const initStatus = async () => {
      try {
        const status = await getStatus();
        if (mounted) {
          setCognitoStatus(status);
        }
      } catch (err) {
        if (mounted) {
          console.error('Failed to initialize Cognito status:', err);
        }
      }
    };

    initStatus();

    return () => {
      mounted = false;
    };
  }, [getStatus]);

  return {
    cognitoStatus,
    loading,
    error,
    getStatus,
    linkAccount,
    isEnabled: cognitoStatus?.enabled || false,
    isOAuthEnabled: cognitoStatus?.oauth_enabled || false
  };
};